import { Box } from "@mui/material";
import React from "react";

import { ResizableWidth } from "./useResizableWidth";

export interface ResizeHandleProps {
  resizable: ResizableWidth;
  label?: string;
}

// A thin vertical strip on the right border of a column, to drag or to
// step with the arrow keys; a double click returns the column to its
// default width. Put it in the gap beside the column.
const ResizeHandle: React.FC<ResizeHandleProps> = ({
  resizable,
  label = "Resize filters",
}) => (
  <Box
    role="separator"
    aria-orientation="vertical"
    aria-label={label}
    aria-valuenow={resizable.width}
    aria-valuemin={resizable.min}
    aria-valuemax={resizable.max}
    tabIndex={0}
    {...resizable.handleProps}
    sx={{
      position: "absolute",
      top: 0,
      bottom: 0,
      right: -12,
      width: 8,
      cursor: "col-resize",
      touchAction: "none",
      userSelect: "none",
      borderRadius: 4,
      backgroundColor: resizable.dragging ? "primary.main" : "transparent",
      opacity: resizable.dragging ? 0.6 : 1,
      transition: "background-color 120ms",
      "&:hover, &:focus-visible": {
        backgroundColor: resizable.dragging ? "primary.main" : "action.hover",
        outline: "none",
      },
    }}
  />
);

export default ResizeHandle;
